var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#fa0000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 385 l-24 -25 59 -60 59 -60 -59 -60 -59 -60 27 -27 27 -27 60 59 60 59 60 -59 60 -59 27 27 27 27 -59 60 -59 60 59 60 59 60 -25 25 -25 26 -63 -57 -62 -57 -42 39 c-84 79 -80 77 -107 49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIcon);
export default __webpack_public_path__ + "static/media/red-icon.d4f341f54da14134afc6bc1a85cc82a6.svg";
export { ForwardRef as ReactComponent };